const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (process.env.NEXT_PUBLIC_API_URL) {
    return process.env.NEXT_PUBLIC_API_URL;
  }
  // Relative routing routes requests through Nginx proxy, bypassing CORS
  return '/api/v1';
};

export const API_BASE_URL = getApiBaseUrl();

export const getWebSocketUrl = (path) => {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const host = window.location.host;

  if (API_BASE_URL.startsWith('/')) {
    return `${protocol}//${host}/api/v1${path}`;
  }

  const wsHost = API_BASE_URL.replace(/^https?:\/\//, '');
  return `${protocol}//${wsHost}${path}`;
};